import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h3>Sorry, Url Not Found</h3>
            <h1>404</h1>
        </div>
    );
};

export default NotFound;